"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimensions = void 0;
exports.dimensions = {
    'Ad Account': 'Attribution.adAccount',
    'Ad Content': 'Attribution.adContent',
    'Ad Platform': 'Attribution.adPlatform',
    'Ad Term': 'Attribution.adTerm',
    Campaign: 'Attribution.campaign',
    Country: 'Attribution.country',
    Device: 'Attribution.device',
    Domain: 'Attribution.domain',
    'Landing page': 'Attribution.landingPageUrl',
    Medium: 'Attribution.medium',
    Source: 'Attribution.source',
    'Source / Medium': 'Attribution.sourceMedium',
};
//# sourceMappingURL=dimensions.js.map